import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {FactorselectionService} from "../service/factorselection.service";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {DisplayService} from "../service/display.service";
import {YmaService} from "../service/yma.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-securid',
  templateUrl: './securid.component.html'
})
export class SecuridComponent implements OnInit, OnDestroy, AfterViewInit {

  errorMsg: string;
  errorDiv: boolean = false;
  displayCodeError: boolean = false;
  userName = null;
  securidForm: UntypedFormGroup;
  factorSelection: boolean = false;
  inlineMessage: string;
  ready: boolean = true;
  otpEntry: string;
  validEntry: boolean;
  pageSubs: Subscription[] = new Array<Subscription>();

  private readonly allowedRSAInputKeys: string[] = [
    'Backspace',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Enter'
  ];

  constructor(private readonly factorselectionService: FactorselectionService,
              private readonly formBuilder: UntypedFormBuilder,
              private readonly ymaService: YmaService,
              private readonly router: Router,
              private readonly displayService: DisplayService) {
    this.displayService.disableBrowserBackButton();
  }

  ngOnInit(): void {
    if (this.displayService.userName == null) {
      this.router.navigate(["../"]);
    }
    this.inlineMessage = this.displayService.inlineMessage || "";
    this.securidForm = this.formBuilder.group({
      code: ['', [Validators.required, Validators.maxLength(10), Validators.pattern("^[0-9]*$")]]
    });
    this.factorSelection = this.displayService.factorSelection;
    this.displayService.focusNthField();
  }

  ngOnDestroy() {
    this.pageSubs.forEach((sub) => {
      sub?.unsubscribe();
    });
  }

  ngAfterViewInit (): void {
    document.getElementById("securid-in").focus();
  }

  onCodeSubmit() {
    this.ready = false;
    this.errorDiv = false;
    this.errorMsg = null;
    this.pageSubs = [
      this.ymaService.onSecurIDLogin(this.securidForm.get('code').value).subscribe({
        next: (data) => {
          this.displayService.routeActions(data);
        },
        error: (err) => {
          this.ready = true;
          this.errorDiv = true;
          let status = err.error?.data?.status;
          if (status === "Reject") {
            this.errorMsg = "Invalid pin+code entered";
          } else if (status === "Terminate") {
            this.router.navigate(['denied']);
          } else {
            this.errorMsg = "System error";
          }
        }
      })
    ];
  }

  factorSelect() {
    this.errorDiv = false;
    this.ready = false;
    this.pageSubs.push(
      this.factorselectionService.chooseAnother()
    );
  }

  public allowOnlyNumbers(event: KeyboardEvent): void {
    if (this.allowedRSAInputKeys.includes(event.key)) {
      return;
    }
    // Block if the key is not a digit 0-9
    if (!/^[/\d]$/.test(event.key)) {
      event.preventDefault();
      // If form isnt completed yet, force the pattern error to be displayed
      if(this.securidForm.controls['code'].value.length != 10) {
        this.securidForm.controls['code'].setErrors({ 'pattern': true });
        this.securidForm.controls['code'].markAsDirty();
      }
    }
  }

}
